class DragDropUpload {

    constructor() {

    }

    init() {

        return {
            onDragEnter: (event, callback) => this.onDragEnter(event, callback),
            onDragLeave: (event, callback) => this.onDragLeave(event, callback),
            onDragOver: (event, callback) => this.onDragOver(event, callback),
            onDrop: (event, callback) => this.onDrop(event, callback)
        }
    }

    onDragEnter(event) {

        event.preventDefault()
        event.stopPropagation()
        event.currentTarget.classList.add('drag-enter')
        event.currentTarget.classList.remove('drag-leave')
    }

    onDragLeave(event) {
        event.preventDefault()
        event.stopPropagation()
        event.currentTarget.classList.remove('drag-enter')
        event.currentTarget.classList.add('drag-leave')
    }

    onDragOver(event) {
        event.preventDefault()
    }

    onDrop(event) {
        event.preventDefault()
        event.stopPropagation()
        event.currentTarget.classList.remove('drag-enter', 'drag-leave')
    }
}

export default new DragDropUpload
